export default [
  {
    path: '/pdf-viewer',
    name: 'pdf-viewer',
    props: route => ({ ...route.query, ...route.params }),
    component: () => import('@/views/components/PdfViewer.vue'),
    meta: {
      pageTitle: 'Pdf view',
      breadcrumb: [
        {
          text: 'Pdf view',
          active: true,
        },
      ],
    },
  },
]
